export default __webpack_public_path__ + "static/media/mfa.a5fff87d.svg";